// @flow

import { takeLatest, call, put } from 'redux-saga/effects';
import type { Saga } from 'redux-saga';

import type { GeneratorType } from 'sagas/root';
import type { FETCH_TEAM_CALENDAR_START_ACTION } from 'actions/team/teamCalendarActions';
import type { ApiExecutorType } from 'types/ApiExecutorType';
import { type ResultCalendarContainerType } from 'types/Result';

import {
  FETCH_TEAM_CALENDAR_START,
  fetchTeamCalendarSuccess,
} from 'actions/team/teamCalendarActions';

import ResultCalendarApi from 'api/resultCalendar/ResultCalendarApi';

export default function(middlewareApiExecutor: ApiExecutorType) {
  const resultCalendarApi = new ResultCalendarApi(middlewareApiExecutor);

  return function* teamCalendarSaga(): GeneratorType {
    yield takeLatest(FETCH_TEAM_CALENDAR_START, fetchResultTeam);
  };

  function* fetchResultTeam(action: FETCH_TEAM_CALENDAR_START_ACTION): Saga<void> {
    try {
      const { payload: { clubID, competitions } } = action;

      const competitionsResponse: ResultCalendarContainerType = clubID
        ? yield call(
          resultCalendarApi.fetchResultCalendar,
          competitions.map((c) => parseInt(c, 10)),
          parseInt(clubID, 10)
        )
        : {};
      yield put(fetchTeamCalendarSuccess(competitionsResponse));

    } catch (err) {
      console.log(err);
      // @TODO: Catch error
    }
  }
};
